import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allSuites: [],
  suites: [],
  filteredSuites: null,
  filteredMySuites: null,
  suite: {
    id: '',
    name: '',
    description: ''
  }
};
export const suiteSlice = createSlice({
  name: 'suiteSlice',
  initialState: initialState,
  reducers: {
    updateSuiteList(state, action) {
      state.suites = action.payload;
    },
    updateAllSuiteList(state, action) {
      state.allSuites = action.payload;
    },
    updateSuite(state, action) {
      state.suite = action.payload;
    },
    resetSuite(state) {
      state.suite = initialState.suite;
    },
    updateFilteredSuites(state, action) {
      state.filteredSuites = action.payload;
    },
    updateFilteredMySuites(state, action) {
      state.filteredMySuites = action.payload;
    },
    clearFilteredSuites(state) {
      state.filteredSuites = null;
      state.filteredMySuites = null;
    }
  }
});

export const suiteActions = suiteSlice.actions;
